import React, { Component } from 'react';
import Avatar from "react-avatar";
import _ from 'lodash';
import './GroupAvatar.scss';

class GroupAvatar extends Component {
  render() {
    const avatarUsers = this.props.users.length > this.props.maxCount ? this.props.users.slice(0, 4) : this.props.users;
    const remainCounts = Math.max(0, this.props.users.length - this.props.maxCount);

    return (
      <div className="group-avatar-container">
        {remainCounts > 0 &&
          <Avatar
            name={`+ ${remainCounts}`}
            size={24}
            round={true}
            fgColor="white"
            className="signle-avatar"
            key="single_avatar_0"
          />
        }
        {avatarUsers.map((user, index) => 
          <Avatar
            name={user.upvoteByName}
            size={24}
            round={true}
            className="signle-avatar"
            key={`single_avatar_${index + 1}`}
            src={_.get(user, 'upvotedByAvatar.medium', null)}
          />
        )}
      </div>
    )
  }
}

export default GroupAvatar;
